import {
  SERVANT_CHANGE, SERVANT_RANK_CHANGE, SERVANT_AVATAR_CHANGED, RANK_CHANGE, FETCH_PARAGON
} from './constants'

const initialState = {
  servants: null,
  avatars: null,
  servantRanks: null,
  ranks: null,
  paragons: null,
}

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case SERVANT_CHANGE:
      return { ...state, servants: action.payload }
    case SERVANT_RANK_CHANGE:
      return { ...state, servantRanks: action.payload }
    case SERVANT_AVATAR_CHANGED:
      return {...state, avatars: {...state.avatars, ...action.payload}}
    case RANK_CHANGE:
      return {...state, ranks: action.payload}
    case FETCH_PARAGON:
      return {...state, paragons: {...state.paragons, ...action.payload}}
    default: return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/servants/index.js